import { graphql } from "@opensea/graphql"
import { FindActiveDropStageFragment } from "../utils"

export const MintActionTimelineDropFragment = graphql(
  `
    fragment MintActionTimelineDrop on Drop {
      identifier {
        contractAddress
        chain {
          identifier
        }
      }
      supportsRelayerFulfillment {
        crossChain
      }
      ...findActiveDropStage
    }
  `,
  [FindActiveDropStageFragment],
)
